export { CarConfigurationSlider } from './CarConfigurationSlider';
